import { render, staticRenderFns } from "./OperatorPermissions.vue?vue&type=template&id=3f21b262&scoped=true&"
import script from "./OperatorPermissions.vue?vue&type=script&lang=js&"
export * from "./OperatorPermissions.vue?vue&type=script&lang=js&"
import style0 from "./OperatorPermissions.vue?vue&type=style&index=0&id=3f21b262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f21b262",
  null
  
)

export default component.exports